import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { fonts } from '@theme/fontsCustomer';

export const Container = styled(Box)`
  width: 100%;
`;

export const ApprovalList = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const NoApprovalContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 100%;
`;

export const NoApproval = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  & .main-text {
    ${fonts.Headline6};
    color: ${({ theme: { colors } }) => colors['text-gray-main']};
  }

  & .sub-text {
    ${fonts.Body2};
    color: ${({ theme: { colors } }) => colors['text-gray-light']};
  }
`;

export const Exclaim = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${({ theme: { colors } }) => colors['bg-primary-lighter']};
  margin-bottom: 8px;
`;
